<template>
  <v-main>
    <v-container fluid>
      <v-btn
        fab
        x-small
        class="mx-2 mb-2"
        color="white"
        @click="$router.back()"
      >
        <v-icon light> mdi-arrow-left </v-icon>
      </v-btn>
      <v-row justify="center">
        <v-col md="12" lg="12" sm="6" class="px-0 pb-0">
          <!-- Main Container -->
          <v-card
            class="mt-4 mb-0 pb-0"
            rounded="xl"
            color="blue lighten-5"
            width="auto"
            min-height="430"
          >
            <v-row class="ma-0">
              <v-col class="pa-0" style="max-width: 300px">
                <h2 class="mx-4 my-4" style="width: 300px" v-if="isActive == 0">
                  Exit Employee Lists
                </h2>
                <h2 class="mx-4 my-4" style="width: 250px" v-else>
                  Employee Lists
                </h2>
              </v-col>
              <v-col
                class="pa-0 ma-2"
                v-if="
                  user.roles[0].name != 'Client' &&
                  user.roles[0].name != 'Employee'
                "
              >
                <v-fab-transition>
                  <v-btn
                    to="/employees/create"
                    color="blue lighten-5"
                    dark
                    absolute
                    fab
                    width="50"
                    height="50"
                  >
                    <v-icon color="blue">mdi-plus</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-col>
              <v-col class="pa-0 ma-2" v-if="user.roles[0].name == 'Admin'">
                <v-fab-transition>
                  <v-btn
                    to="/employees/upload"
                    color="blue lighten-5"
                    dark
                    absolute
                    fab
                    width="50"
                    height="50"
                  >
                    <v-icon color="blue">mdi-upload</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-col>
            </v-row>
            <v-row class="mx-4 mx-2 my-4" v-if="user.roles[0].name == 'Admin'">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Select Client</h5>
                <v-select
                  solo
                  hide-details=""
                  dense
                  rounded
                  v-model="form.site_id"
                  :items="sites"
                  label="Client"
                  @change="getData"
                ></v-select>
              </v-col>
            </v-row>
            <template v-if="employees.length > 0">
              <v-container
                :style="`height: ${
                  user.roles[0].name === 'Client' ? '630px' : '350px'
                }; overflow-y: auto`"
              >
                <v-row class="ma-0">
                  <v-col class="pa-0 mx-3 mb-6">
                    <v-expansion-panels>
                      <v-expansion-panel
                        v-for="employee in employees"
                        :key="employee.id"
                      >
                        <v-expansion-panel-header>
                          <v-row class="ma-0">
                            <v-col cols="10" class="pa-0">
                              <span>{{ employee.full_name }}</span>
                            </v-col>
                            <v-col
                              cols="2"
                              class="pa-0"
                              align="right"
                              v-if="user.roles[0].name != 'Client'"
                            >
                              <v-fab-transition>
                                <v-btn
                                  :to="`/employees/${employee.id}`"
                                  color="blue lighten-5"
                                  dark
                                  fab
                                  x-small
                                >
                                  <v-icon color="blue">mdi-pencil</v-icon>
                                </v-btn>
                              </v-fab-transition>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" style="max-width: 100px">
                              <span>Email</span>
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span>: {{ employee.email }}</span>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" style="max-width: 100px">
                              <span>Emp Code</span>
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span>: {{ employee.employee_id || "" }}</span>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" style="max-width: 100px">
                              <span>Division</span>
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span
                                >:
                                {{
                                  employee.group_division?.division_name || ""
                                }}</span
                              >
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" style="max-width: 100px">
                              <span>Mobile</span>
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span>: {{ employee.mobile || "" }}</span>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" align="left">
                              <span
                                >Is Active:
                                {{ employee.active == 1 ? "Yes" : "No" }}</span
                              >
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span
                                >Is Reliever:
                                {{
                                  employee.is_reliever == 1 ? "Yes" : "No"
                                }}</span
                              >
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </template>

            <template
              v-if="user.roles[0].name == 'Admin' && new_users.length > 0"
            >
              <h5 class="text-center">New Added Employees</h5>
              <v-container style="height: 300px; overflow-y: auto">
                <v-row class="ma-0">
                  <v-col class="pa-0 mx-3 mb-6">
                    <v-expansion-panels>
                      <v-expansion-panel
                        v-for="new_employee in new_users"
                        :key="new_employee.id"
                      >
                        <v-expansion-panel-header>
                          <v-row class="ma-0">
                            <v-col cols="10" class="pa-0">
                              <span>{{ new_employee.full_name }}</span>
                            </v-col>
                            <v-col cols="2" class="pa-0" align="right">
                              <v-fab-transition>
                                <v-btn
                                  :to="`/employees/${new_employee.id}`"
                                  color="blue lighten-5"
                                  dark
                                  fab
                                  x-small
                                  v-if="user.roles[0].name != 'Client'"
                                >
                                  <v-icon color="blue">mdi-pencil</v-icon>
                                </v-btn>
                              </v-fab-transition>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" style="max-width: 100px">
                              <span>Email</span>
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span>: {{ new_employee.email }}</span>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0 py-1">
                            <v-col class="pa-0" style="max-width: 100px">
                              <span>Mobile</span>
                            </v-col>
                            <v-col class="pa-0" align="left">
                              <span>: {{ new_employee.mobile || "" }}</span>
                            </v-col>
                          </v-row>
                          <v-fab-transition>
                            <v-btn
                              :to="`/employees/${new_employee.id}/documents`"
                              color="blue lighten-5"
                              dark
                              fab
                              x-small
                            >
                              <v-icon color="blue">mdi-plus</v-icon>
                            </v-btn>
                          </v-fab-transition>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </template>

            <template v-if="employees.length == 0 && !isLoading">
              <v-row justify="center">
                <v-col align="center" style="min-height: 100px">
                  <span> No employee found. </span>
                </v-col>
              </v-row>
            </template>
            <template
              v-if="
                user.roles[0].name == 'Admin' &&
                new_users.length == 0 &&
                !isLoading
              "
            >
              <v-row justify="center">
                <v-col align="center" style="min-height: 100px">
                  <span> No new employee found. </span>
                </v-col>
              </v-row>
            </template>
            <template v-if="isLoading">
              <v-row justify="center">
                <v-col align="center" style="min-height: 100px">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="blue"
                    indeterminate
                  ></v-progress-circular>
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
export default {
  components: { backbutton },
  name: "UsersPage",
  data() {
    return {
      employees: [],
      new_users: [],
      isLoading: false,
      sites: [],
      form: {},
      isActive: "",
    };
  },
  mounted() {
    this.isActive = this.$route.query.isActive == "true" ? 1 : 0;
    if (
      this.user.roles[0].name == "Client" ||
      this.user.roles[0].name == "Supervisor" ||
      this.user.roles[0].name == "Admin"
    ) {
      this.form.site_id = this.user.sites[0].id;
      this.getData();
    }
    if (
      this.user.roles[0].name == "Admin" ||
      this.user.roles[0].name == "Supervisor"
    ) {
      this.getMasters();
    }
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(
        `/monthly_salaries/masters?site_id=${this.site.id}`
      );
      masters = masters.data;
      masters.sites.forEach((site) => {
        this.sites.push({
          id: site.id,
          text: site.name,
          value: site.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      this.employees = [];
      let employees = await axios.get(
        `users?site_id=${this.form.site_id}&role_id=3&is_active=${this.isActive}`
      );
      this.employees = employees.data.data;

      this.new_users = [];
      let new_users = await axios.get(
        `users?site_id=${this.form.site_id}&role_id=3&is_new=yes`
      );
      this.new_users = new_users.data.data;
      this.isLoading = false;
    },
  },
};
</script>
